import type { DefineComponent, AsyncComponentLoader } from 'vue';

const lazyPage =
  <T extends Record<string, any>>(
    importFn: () => Promise<T>,
    exportName: keyof T,
  ): AsyncComponentLoader<DefineComponent> =>
  async () => {
    const module = await importFn();
    const component = module[exportName];

    if (!component) {
      throw new Error(`Component "${String(exportName)}" not found in module.`);
    }

    return component;
  };

export { lazyPage };
